import { APP_TIME_ZONE } from "./timeZone";

export const formatAuditDate = (value: string): string => {
  try {
    const date = new Date(value);
    return date.toLocaleString("en-AU", {
      timeZone: APP_TIME_ZONE,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  } catch {
    return value;
  }
};

export const formatAuditTime24Hour = (value: string): string => {
  try {
    const date = new Date(value);
    return date.toLocaleString("en-AU", {
      timeZone: APP_TIME_ZONE,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  } catch {
    return value;
  }
};
